import { API_BASE_URL } from './config';
import { apiFetch } from './apiFetch';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export type MilestoneTemplateDto = {
  id: string;
  companyId: string;
  positionId: string | null;
  orgLevelId: string | null;
  name: string;
  milestone30: string | null;
  milestone90: string | null;
  milestone180: string | null;
  createdAt: string;
  updatedAt: string;
};

export async function listMilestoneTemplates(companyId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/milestone-templates?companyId=${companyId}`, {
    headers: JSON_HEADERS,
  });
  return res.json() as Promise<{
    success: boolean;
    data?: { templates: MilestoneTemplateDto[] };
    error?: string;
  }>;
}

export async function createMilestoneTemplate(input: {
  companyId: string;
  name: string;
  positionId?: string;
  orgLevelId?: string;
  milestone30?: string;
  milestone90?: string;
  milestone180?: string;
}) {
  const res = await apiFetch(`${API_BASE_URL}/api/milestone-templates`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { id: string }; error?: string }>;
}

export async function updateMilestoneTemplate(
  id: string,
  input: {
    companyId: string;
    name?: string;
    positionId?: string;
    orgLevelId?: string;
    milestone30?: string;
    milestone90?: string;
    milestone180?: string;
  },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/milestone-templates/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}

export async function deleteMilestoneTemplate(id: string, companyId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/milestone-templates/${id}?companyId=${companyId}`, {
    method: 'DELETE',
    headers: JSON_HEADERS,
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}
